import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    try {
      let loginEmail = email.trim().toLowerCase();
      if (!loginEmail.includes('@')) {
        loginEmail = `${loginEmail}@bnnz.net`;
      }
      await login(loginEmail, password);
      toast.success('Welcome back!');
    } catch (error) {
      const message = error.response?.data?.detail || 'Login failed';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zom-yellow flex flex-col items-center justify-center p-6">
      {/* LOGO */}
      <div className="mb-8 text-center">
        <img 
          src="/zombify-logo.png" 
          alt="ZOMBIFY" 
          className="w-64 h-auto mx-auto"
        />
      </div>

      {/* LOGIN FORM - BRUTAL */}
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4">
        <div>
          <input
            type="text"
            placeholder="USERNAME"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-zom-white border-3 border-zom-black text-zom-black placeholder:text-zom-black/40 h-14 px-4 font-heading text-sm tracking-wide shadow-brutal focus:shadow-brutal-lg transition-shadow"
            data-testid="login-email-input"
          />
        </div>
        
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="PASSWORD"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-zom-white border-3 border-zom-black text-zom-black placeholder:text-zom-black/40 h-14 px-4 pr-14 font-heading text-sm tracking-wide shadow-brutal focus:shadow-brutal-lg transition-shadow"
            data-testid="login-password-input"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-zom-black hover:text-zom-red transition-colors"
            data-testid="toggle-password-btn"
          >
            {showPassword ? <EyeOff className="w-6 h-6" strokeWidth={3} /> : <Eye className="w-6 h-6" strokeWidth={3} />}
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full h-14 border-3 border-zom-blue bg-transparent text-zom-blue font-heading text-lg tracking-widest hover:bg-zom-blue hover:text-zom-white transition-all disabled:opacity-50 shadow-brutal hover:shadow-brutal-lg"
          data-testid="login-submit-btn"
        >
          {loading ? (
            <div className="w-6 h-6 border-3 border-current border-t-transparent animate-spin mx-auto" />
          ) : (
            'ROZPOCZNIJ'
          )}
        </button>
      </form>

      <p className="text-zom-black/50 text-xs mt-12 text-center font-body tracking-wide">
        INTERNAL USE ONLY
      </p>
    </div>
  );
};

export default LoginPage;
